<script setup lang="ts">
    import { INVOICE_TYPES } from '~/utils/aiEntityMeta';

    const props = defineProps<{
        type: string;
        id: string;
    }>();

    defineEmits<{
        close: [];
    }>();

    const isInvoiceType = computed(() => (INVOICE_TYPES as readonly string[]).includes(props.type));
</script>

<template>
    <AiPageEntityPreviewInvoice v-if="isInvoiceType" :type="type" :id="id" @close="$emit('close')" />
    <AiPageEntityPreviewContact v-else-if="type === 'contact'" :id="id" @close="$emit('close')" />
    <AiPageEntityPreviewWorksite v-else-if="type === 'worksite'" :id="id" @close="$emit('close')" />
    <div v-else class="flex-1 flex items-center justify-center">
        <p class="text-[13px] text-gray-400">{{ $t('ai.preview.unavailable') }}</p>
    </div>
</template>
